export default __webpack_public_path__ + "static/media/freeToJoin.a94c3528.png";